import isEmpty from 'lodash/isEmpty';
import { RuleFilterConfig } from '../constants/createSegment';

export const getApplicableFilters = parsedRuleFilters => {
  let updatedFilter = [];
  Object.keys(RuleFilterConfig)?.forEach(filter => {
    const hasEmptyValues = RuleFilterConfig[filter]?.some(key => {
      if (typeof parsedRuleFilters[key] === 'number') {
        return parsedRuleFilters[key] === 0;
      }
      return isEmpty(parsedRuleFilters[key]);
    });
    if (!hasEmptyValues) {
      updatedFilter.push(filter);
    }
  });
  return updatedFilter;
};
